import React, { useState } from 'react'
import AppIcon from '../AppIcon/AppIcon'
import AlbumWindow from '../Windows/AlbumWindow/AlbumWindow'
import MusicWindow from '../Windows/MusicWindow/MusicWindow'
import NoteWindow from '../Windows/NoteWindow/NoteWindow'
import ImageLogo from '../../assets/logos/photos.png'
import EmailLogo from '../../assets/logos/email.png'
import MusicIcon from '../../assets/icons/Apps/music-icon-large.png'
import NoteIcon from '../../assets/icons/Apps/note-icon.png'
import './Footer.css'

function Footer({ onChangeBackground }) {
  const [isAlbumWindowOpen, setIsAlbumWindowOpen] = useState(false)
  const [isMusicWindowOpen, setIsMusicWindowOpen] = useState(false)
  const [isNoteWindowOpen, setIsNoteWindowOpen] = useState(false)
  const [hoveredIcon, setHoveredIcon] = useState(null) // 用于控制悬停显示的文字

  const handleAlbumClick = () => {
    setIsAlbumWindowOpen(true)
  }

  const closeAlbumWindow = () => {
    setIsAlbumWindowOpen(false)
  }

  const handleMusicClick = () => {
    setIsMusicWindowOpen(true)
  }

  const closeMusicWindow = () => {
    setIsMusicWindowOpen(false)
  }

  const handleNoteClick = () => {
    setIsNoteWindowOpen(true)
  }

  const closeNoteWindow = () => {
    setIsNoteWindowOpen(false)
  }

  return (
    <>
      <footer className="footer">
        <div
          className="app-icon-container"
          onMouseEnter={() => setHoveredIcon('Album')}
          onMouseLeave={() => setHoveredIcon(null)}
          onClick={handleAlbumClick}
          style={{ cursor: 'pointer' }}
        >
          <AppIcon src={ImageLogo} alt="Photos" />
          {hoveredIcon === 'Album' && <div className="tooltip">Album</div>}
        </div>

        <div
          className="app-icon-container"
          onMouseEnter={() => setHoveredIcon('Email')}
          onMouseLeave={() => setHoveredIcon(null)}
        >
          <a href="mailto:easestardev@gmail.com">
            <AppIcon src={EmailLogo} alt="Email Icon" />
          </a>
          {hoveredIcon === 'Email' && <div className="tooltip">Contact Me</div>}
        </div>

        <div
          className="app-icon-container"
          onMouseEnter={() => setHoveredIcon('Music')}
          onMouseLeave={() => setHoveredIcon(null)}
          onClick={handleMusicClick}
          style={{ cursor: 'pointer' }}
        >
          <AppIcon src={MusicIcon} alt="Music Icon" />
          {hoveredIcon === 'Music' && <div className="tooltip">Music</div>}
        </div>

        <div
          className="app-icon-container"
          onMouseEnter={() => setHoveredIcon('Note')}
          onMouseLeave={() => setHoveredIcon(null)}
          onClick={handleNoteClick}
          style={{ cursor: 'pointer' }}
        >
          <AppIcon src={NoteIcon} alt="Note Icon" />
          {hoveredIcon === 'Note' && <div className="tooltip">Notes</div>}
        </div>
      </footer>

      {isAlbumWindowOpen && (
        <AlbumWindow
          onClose={closeAlbumWindow}
          onChangeBackground={onChangeBackground}
        />
      )}

      {isMusicWindowOpen && <MusicWindow onClose={closeMusicWindow} />}

      {isNoteWindowOpen && <NoteWindow onClose={closeNoteWindow} />}
    </>
  )
}

export default Footer
